import { type ImageFormats } from '@components/helpers/imagesImports';

type PlantTypeText =
  | 'lumber'
  | 'textiles'
  | 'bricks'
  | 'paper'
  | 'steel'
  | 'plastic'
  | 'glass'
  | 'fuels_and_oils'
  | 'microchips';

type PlantCategory = {
  background: ImageFormats;
  build: ImageFormats;
  icon: ImageFormats;
};

type PlantTypeImages = Record<PlantTypeText, PlantCategory>;

const plantTypesArray: PlantTypeText[] = [
  'lumber',
  'textiles',
  'bricks',
  'paper',
  'steel',
  'plastic',
  'glass',
  'fuels_and_oils',
  'microchips',
];

interface CalcBoostType {
  effectMultiplier: number;
  startedAt: Date;
  endDate: Date;
}

export {
  type CalcBoostType,
  type PlantCategory,
  type PlantTypeImages,
  plantTypesArray,
  type PlantTypeText,
};
